module.exports = __webpack_public_path__ + "img/cleanup4-7-8-2021.e68c10b6.jpg";